import React from "react";
export const TabsNavContext = React.createContext<{
  selected: boolean;
  id: string | number;
  onSelectTab: (id: string | number) => void;
}>({ selected: false, id: 0, onSelectTab: () => {} });
